export class User {
    login?: string;
    password?: string;
    token?: string | null;
}
